"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CategoryManager = void 0;
var react_1 = __importDefault(require("react"));
var icons_1 = require("@ant-design/icons");
var messageContext_1 = require("../../hoc/messageContext");
var form_1 = __importDefault(require("antd/es/form"));
var input_1 = __importDefault(require("antd/es/input"));
var input_number_1 = __importDefault(require("antd/es/input-number"));
var button_1 = __importDefault(require("antd/es/button"));
var modal_1 = __importDefault(require("antd/es/modal"));
var select_1 = __importDefault(require("antd/es/select"));
var space_1 = __importDefault(require("antd/es/space"));
var table_1 = __importDefault(require("antd/es/table"));
var CategoryManager = function (_a) {
    var items = _a.items, endpoint = _a.endpoint, title = _a.title, onUpdate = _a.onUpdate, brands = _a.brands, models = _a.models, dataKey = _a.dataKey;
    var form = form_1.default.useForm()[0];
    var _b = (0, messageContext_1.useMessageContext)(), showSuccess = _b.showSuccess, showError = _b.showError;
    var _c = react_1.default.useState(false), isModalVisible = _c[0], setIsModalVisible = _c[1];
    var _d = react_1.default.useState(null), editingItem = _d[0], setEditingItem = _d[1];
    var _e = react_1.default.useState(false), loading = _e[0], setLoading = _e[1];
    var isEngineCapacity = function (item) { return 'capacity' in item; };
    var isEnginePower = function (item) { return 'power' in item; };
    var isModel = endpoint === 'models';
    var isGeneration = endpoint === 'generations';
    var handleAdd = function () {
        setEditingItem(null);
        form.resetFields();
        if (endpoint === 'gearbox_types') {
            form.setFieldsValue({
                name: '',
                abbreviation: '',
            });
        }
        setIsModalVisible(true);
    };
    var handleEdit = function (record) {
        setEditingItem(record);
        if (isEngineCapacity(record)) {
            form.setFieldsValue({ capacity: record.capacity });
        }
        else if (isEnginePower(record)) {
            form.setFieldsValue({ power: record.power });
        }
        else if ('abbreviation' in record) {
            form.setFieldsValue({
                name: record.name,
                abbreviation: record.abbreviation,
            });
        }
        else {
            form.setFieldsValue({ name: record.name });
        }
        setIsModalVisible(true);
    };
    var handleDelete = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, fetch("".concat(process.env.REACT_APP_BASE_URL, "/").concat(endpoint, "/").concat(id), {
                            method: 'DELETE',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                        })];
                case 1:
                    response = _a.sent();
                    if (response.ok) {
                        showSuccess('Успешно удалено');
                        onUpdate();
                    }
                    else {
                        showError('Ошибка при удалении');
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    showError('Ошибка при удалении');
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleSubmit = function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var method, url, payload, response, error_2;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setLoading(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    method = editingItem ? 'PATCH' : 'POST';
                    url = editingItem
                        ? "".concat(process.env.REACT_APP_BASE_URL, "/").concat(endpoint, "/").concat(editingItem.id)
                        : "".concat(process.env.REACT_APP_BASE_URL, "/").concat(endpoint);
                    if (endpoint === 'gearbox_types' && (!values.name || !values.abbreviation)) {
                        showError('Необходимо заполнить название и аббревиатуру');
                        return [2 /*return*/];
                    }
                    payload = (_a = {},
                        _a[dataKey] = __assign(__assign({}, values), (endpoint === 'gearbox_types' && {
                            name: values.name,
                            abbreviation: values.abbreviation,
                        })),
                        _a);
                    return [4 /*yield*/, fetch(url, {
                            method: method,
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify(payload),
                        })];
                case 2:
                    response = _b.sent();
                    if (response.ok) {
                        showSuccess("".concat(title, " \u0443\u0441\u043F\u0435\u0448\u043D\u043E ").concat(editingItem ? 'обновлен' : 'добавлен'));
                        setIsModalVisible(false);
                        onUpdate();
                    }
                    else {
                        showError("\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 ".concat(editingItem ? 'обновлении' : 'добавлении'));
                    }
                    return [3 /*break*/, 5];
                case 3:
                    error_2 = _b.sent();
                    showError("\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 ".concat(editingItem ? 'обновлении' : 'добавлении'));
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var isModelRecord = function (record) { return 'brand_id' in record; };
    var isGenerationRecord = function (record) { return 'model_id' in record; };
    var getColumns = function () {
        var baseColumns = [
            {
                title: 'ID',
                dataIndex: 'id',
                key: 'id',
                width: 80,
                sorter: function (a, b) { return a.id - b.id; },
            },
        ];
        if (items.length > 0) {
            if (isEngineCapacity(items[0])) {
                baseColumns.push({
                    title: 'Объем',
                    dataIndex: 'capacity',
                    key: 'capacity',
                    sorter: function (a, b) {
                        if (isEngineCapacity(a) && isEngineCapacity(b)) {
                            return a.capacity - b.capacity;
                        }
                        return 0;
                    },
                });
            }
            else if (isEnginePower(items[0])) {
                baseColumns.push({
                    title: 'Мощность',
                    dataIndex: 'power',
                    key: 'power',
                    sorter: function (a, b) {
                        if (isEnginePower(a) && isEnginePower(b)) {
                            return a.power - b.power;
                        }
                        return 0;
                    },
                });
            }
            else {
                baseColumns.push({
                    title: 'Название',
                    dataIndex: 'name',
                    key: 'name',
                    sorter: function (a, b) {
                        var nameA = 'name' in a ? a.name : '';
                        var nameB = 'name' in b ? b.name : '';
                        return nameA.localeCompare(nameB);
                    },
                });
                if (endpoint === 'gearbox_types') {
                    baseColumns.push({
                        title: 'Аббревиатура',
                        dataIndex: 'abbreviation',
                        key: 'abbreviation',
                    });
                }
                if (isModel && brands) {
                    baseColumns.push({
                        title: 'Бренд',
                        key: 'brand',
                        render: function (_, record) {
                            if (isModelRecord(record)) {
                                var brand = brands.find(function (b) { return b.id === record.brand_id; });
                                return (brand === null || brand === void 0 ? void 0 : brand.name) || 'Неизвестно';
                            }
                            return 'Неизвестно';
                        },
                    });
                }
                if (isGeneration && models) {
                    baseColumns.push({
                        title: 'Модель',
                        key: 'model',
                        render: function (_, record) {
                            if (isGenerationRecord(record)) {
                                var model = models.find(function (m) { return m.id === record.model_id; });
                                return (model === null || model === void 0 ? void 0 : model.name) || 'Неизвестно';
                            }
                            return 'Неизвестно';
                        },
                    });
                }
            }
        }
        baseColumns.push({
            title: 'Действия',
            key: 'actions',
            width: 120,
            render: function (_, record) { return (react_1.default.createElement(space_1.default, null,
                react_1.default.createElement(button_1.default, { icon: react_1.default.createElement(icons_1.EditOutlined, null), onClick: function () { return handleEdit(record); } }),
                react_1.default.createElement(button_1.default, { icon: react_1.default.createElement(icons_1.DeleteOutlined, null), danger: true, onClick: function () { return handleDelete(record.id); } }))); },
        });
        return baseColumns;
    };
    var getFormItems = function () {
        if (!editingItem && endpoint === 'gearbox_types') {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(form_1.default.Item, { name: "name", label: "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435", rules: [{ required: true, message: 'Введите название' }] },
                    react_1.default.createElement(input_1.default, { placeholder: "\u041D\u0430\u043F\u0440\u0438\u043C\u0435\u0440: \u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0430\u044F" })),
                react_1.default.createElement(form_1.default.Item, { name: "abbreviation", label: "\u0410\u0431\u0431\u0440\u0435\u0432\u0438\u0430\u0442\u0443\u0440\u0430", rules: [{ required: true, message: 'Введите аббревиатуру' }], tooltip: "\u0421\u043E\u043A\u0440\u0430\u0449\u0435\u043D\u043D\u043E\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u043A\u043E\u0440\u043E\u0431\u043A\u0438 \u043F\u0435\u0440\u0435\u0434\u0430\u0447" },
                    react_1.default.createElement(input_1.default, { placeholder: "\u041D\u0430\u043F\u0440\u0438\u043C\u0435\u0440: \u0410\u041A\u041F\u041F" }))));
        }
        if (items.length > 0) {
            if (isEngineCapacity(items[0])) {
                return (react_1.default.createElement(form_1.default.Item, { name: "capacity", label: "\u041E\u0431\u044A\u0435\u043C \u0434\u0432\u0438\u0433\u0430\u0442\u0435\u043B\u044F", rules: [{ required: true, message: 'Введите объем двигателя' }] },
                    react_1.default.createElement(input_number_1.default, { min: 0, step: 0.1, style: { width: '100%' } })));
            }
            else if (isEnginePower(items[0])) {
                return (react_1.default.createElement(form_1.default.Item, { name: "power", label: "\u041C\u043E\u0449\u043D\u043E\u0441\u0442\u044C \u0434\u0432\u0438\u0433\u0430\u0442\u0435\u043B\u044F", rules: [{ required: true, message: 'Введите мощность двигателя' }] },
                    react_1.default.createElement(input_number_1.default, { min: 0, style: { width: '100%' } })));
            }
        }
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(form_1.default.Item, { name: "name", label: "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435", rules: [{ required: true, message: 'Введите название' }] },
                react_1.default.createElement(input_1.default, null)),
            endpoint === 'gearbox_types' && (react_1.default.createElement(form_1.default.Item, { name: "abbreviation", label: "\u0410\u0431\u0431\u0440\u0435\u0432\u0438\u0430\u0442\u0443\u0440\u0430", rules: [{ required: true, message: 'Введите аббревиатуру' }], tooltip: "\u0421\u043E\u043A\u0440\u0430\u0449\u0435\u043D\u043D\u043E\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u043A\u043E\u0440\u043E\u0431\u043A\u0438 \u043F\u0435\u0440\u0435\u0434\u0430\u0447" },
                react_1.default.createElement(input_1.default, { placeholder: "\u041D\u0430\u043F\u0440\u0438\u043C\u0435\u0440: \u0410\u041A\u041F\u041F, \u041C\u041A\u041F\u041F, \u0420\u041A\u041F" }))),
            isModel && brands && (react_1.default.createElement(form_1.default.Item, { name: "brand_id", label: "\u0411\u0440\u0435\u043D\u0434", rules: [{ required: true, message: 'Выберите бренд' }] },
                react_1.default.createElement(select_1.default, { showSearch: true, optionFilterProp: "children", placeholder: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0431\u0440\u0435\u043D\u0434" }, brands.map(function (brand) { return (react_1.default.createElement(select_1.default.Option, { key: brand.id, value: brand.id }, brand.name)); })))),
            isGeneration && models && (react_1.default.createElement(form_1.default.Item, { name: "model_id", label: "\u041C\u043E\u0434\u0435\u043B\u044C", rules: [{ required: true, message: 'Выберите модель' }] },
                react_1.default.createElement(select_1.default, { showSearch: true, optionFilterProp: "children", placeholder: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043C\u043E\u0434\u0435\u043B\u044C" }, models.map(function (model) { return (react_1.default.createElement(select_1.default.Option, { key: model.id, value: model.id }, model.name)); }))))));
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { style: { marginBottom: 16 } },
            react_1.default.createElement(button_1.default, { type: "primary", icon: react_1.default.createElement(icons_1.PlusOutlined, null), onClick: handleAdd },
                "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C ",
                title.toLowerCase())),
        react_1.default.createElement(table_1.default, { dataSource: items, columns: getColumns(), rowKey: "id", pagination: { pageSize: 10 } }),
        react_1.default.createElement(modal_1.default, { title: "".concat(editingItem ? 'Редактировать' : 'Добавить', " ").concat(title.toLowerCase()), open: isModalVisible, onCancel: function () { return setIsModalVisible(false); }, footer: null },
            react_1.default.createElement(form_1.default, { form: form, onFinish: handleSubmit, layout: "vertical" },
                getFormItems(),
                react_1.default.createElement(form_1.default.Item, null,
                    react_1.default.createElement(space_1.default, null,
                        react_1.default.createElement(button_1.default, { type: "primary", htmlType: "submit", loading: loading }, editingItem ? 'Сохранить' : 'Добавить'),
                        react_1.default.createElement(button_1.default, { onClick: function () { return setIsModalVisible(false); } }, "\u041E\u0442\u043C\u0435\u043D\u0430")))))));
};
exports.CategoryManager = CategoryManager;
